<div class="d-flex align-items-center position-relative chip-input">
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>{{label}}</mat-label>
      <mat-chip-grid #chipGrid aria-label="Enter email addresses">
        <mat-chip-row
          *ngFor="let email of formControl.value|| []; index as i"
          [removable]="true"
          (removed)="remove(i)"
        >
          {{ email }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
  
        <input
          [placeholder]="placeholder"
          #input
          [formControl]="inputFilterControl"
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          [matAutocomplete]="auto"
        />
      </mat-chip-grid>
  
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="addSuggestion($event)"
      >
        <mat-option
          *ngFor="let suggestion of suggestions"
          [value]="suggestion"
        >
          {{ suggestion }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  
    <span *ngIf="showLoader" class="loader">Loading...</span>
  </div>